var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82076 8.81413C7.145 9.24761 7.55868 9.60628 8.03373 9.86582C8.50878 10.1254 9.0341 10.2797 9.57404 10.3184C10.114 10.357 10.6559 10.2791 11.1631 10.0899C11.6703 9.90075 12.1309 9.60468 12.5136 9.22184L14.7786 6.95679C15.4663 6.2448 15.8468 5.29121 15.8382 4.30139C15.8296 3.31158 15.4326 2.36474 14.7326 1.66481C14.0327 0.964878 13.0859 0.567856 12.0961 0.559255C11.1062 0.550654 10.1527 0.931161 9.44067 1.61882L8.14204 2.9099M9.84082 7.3041C9.51658 6.87062 9.1029 6.51195 8.62785 6.2524C8.1528 5.99286 7.62749 5.83852 7.08754 5.79985C6.5476 5.76118 6.00565 5.83909 5.49846 6.02828C4.99128 6.21748 4.53071 6.51354 4.148 6.89639L1.88295 9.16144C1.19529 9.87343 0.814784 10.827 0.823385 11.8168C0.831986 12.8066 1.22901 13.7535 1.92894 14.4534C2.62887 15.1533 3.57571 15.5504 4.56552 15.559C5.55534 15.5676 6.50893 15.1871 7.22092 14.4994L8.512 13.2083",
    stroke: "#4E5574",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2d58ef8c64e607a98037317bc2096a53.svg";
export { ForwardRef as ReactComponent };